import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.598 11.52a.667.667 0 1 0 1.24-.493l-.747-1.88 4.427-.98v3.166a.667.667 0 1 0 1.334 0V8.167l4.426.98-.747 1.88a.666.666 0 0 0 .995.798.67.67 0 0 0 .245-.305l1.034-2.607a.67.67 0 0 0-.034-.56.67.67 0 0 0-.44-.34l-2.146-.473V4.667A.667.667 0 0 0 11.518 4h-1.333V2a.667.667 0 0 0-.667-.667H6.851A.667.667 0 0 0 6.185 2v2H4.852a.667.667 0 0 0-.667.667V7.54L2.038 8a.67.67 0 0 0-.44.34.67.67 0 0 0-.033.56zm4.92-8.853h1.334V4H7.518zm-2 2.666h5.334V7.24l-2.52-.573h-.294l-2.52.573zm8.474 7.52a3 3 0 0 0-.667.3 1.39 1.39 0 0 1-1.4 0 3.08 3.08 0 0 0-3.027 0 1.43 1.43 0 0 1-1.413 0 3.09 3.09 0 0 0-3.027 0 1.39 1.39 0 0 1-1.4 0 3 3 0 0 0-.666-.3.665.665 0 0 0-.874.48.667.667 0 0 0 .447.827q.202.055.38.167c.404.237.864.364 1.333.366a2.76 2.76 0 0 0 1.387-.373 1.77 1.77 0 0 1 1.706 0 2.77 2.77 0 0 0 2.747 0 1.77 1.77 0 0 1 1.707 0 2.67 2.67 0 0 0 2.733 0q.178-.111.38-.167a.67.67 0 0 0 .514-.82.666.666 0 0 0-.86-.48"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })